import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './scss/polymer-scss.scss';
import { PersistGate } from 'redux-persist/integration/react';
import { FinancialPlanProvider } from './context/financial-plan-contenxt';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (document.location.origin === "https://services3.hdb.gov.sg") {
  console.log = () => {};
}

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <FinancialPlanProvider>
        <App />
      </FinancialPlanProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
